import request from "../utils/request";


// pc端通过动态码获取项目草稿 /api/Porject/getCodeProjectCg
export function getCodeProjectCg(params, options = {}) {
    return request({
        url: "/api/face/records/info",
        method: "get",
        params,
        ...options
    });
}

// 根据诊断报告获取推荐商品
export function getRecommendationListByRecord(data, options = {}) {
    return request({
        url: "/api/goods/recommendationListByRecord",
        method: "post",
        data,
        ...options
    });
}

// 根据标签获取推荐商品
export function recommendationList(data, options = {}) {
    return request({
        url: "/api/goods/recommendationList",
        method: "post",
        data,
        ...options
    });
}

// 根据组合报告ID获取脉诊组合报告
export function getCombinedMaiReport(combinedId, accessSession, options = {}) {
    const headers = {
        'X-SDKClient-API-Key': 'e517ed538290423083825f6078985c9b',
        Authorization: `Bearer ${accessSession || ''}`,
        ...(options.headers || {})
    }

    return request({
        url: "https://api.reborn-tech.com/pmsecurity/report/getCombinedMai",
        method: "get",
        params: {
            combinedId
        },
        ...options,
        headers
    });
}

// 获取脉诊分析
export function getMaiZFx(data, options = {}) {
    return request({
        url: "/api/face/getMaiZFx",
        method: "post",
        data,
        ...options
    });
}
